module.exports = __webpack_public_path__ + "img/tc2.5d1ac522.png";